import { HttpContext, HttpContextToken } from '@angular/common/http';

export const SUPPRESS_GLOBAL_ERROR_FEEDBACK = new HttpContextToken<boolean>(
  () => false
);

export function suppressGlobalErrorFeedback(): HttpContext {
  return new HttpContext().set(SUPPRESS_GLOBAL_ERROR_FEEDBACK, true);
}
